import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { Storage } from '@ionic/storage';

@Injectable()
export class StorageService {
	app: string = environment.app;
	private _storage: Storage | null = null;
	constructor(private storage: Storage) {
		this.init();
	}

	async init() {
		const storage = await this.storage.create();
		this._storage = storage;
	}

	async get(key: string): Promise<any> {
		return await this.storage.get(`${this.app}-${key}`);
	}

	public set(key: string, value: any) {
		this._storage?.set(`${this.app}-${key}`, value);
	}

	public remove(key: string) {
		this.storage.remove(`${this.app}-${key}`);
	}
}
